<template>
	<div class="container__plantiosEstrato">
		<GmapMap
			ref="planejamento_estrato_map"
			map-type-id="satellite"
			class="container__googlemaps__position"
			:center="{ lat: -17.390269, lng: -40.538804 }"
			:zoom="16"
		>
			<PolygonShape
				:editable="false"
				:options="shapeOptionsFzda"
				:coordinates="getGeoJsonFzda.coordinates"
				:type="getGeoJsonFzda.type"
				:clickable="true"
			/>
			<!-- <PolygonShape
        v-for="(coordinateAndType) in getGeoJsonTlho.features"
        :key="coordinateAndType.properties['Codigo do Talhao']"
        :editable="false"
        :options="shapeOptionsTlho"
        :coordinates="coordinateAndType.coordinates"
        :type="coordinateAndType.type"
        :clickable="true"
      /> -->
			<PolygonShape
				v-for="coordinateAndType in getGeoJsonPtio.features"
				:key="coordinateAndType.properties['Codigo Plantio']"
				:editable="false"
				:position="coordinateAndType.position"
				:options="
					shapeOptionsPtio(
						Object.assign(coordinateAndType.properties, {
							mostraContinuos: mostraContinuos,
							mostraPreCorte: mostraPreCorte,
						}),
					)
				"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
				:properties="coordinateAndType.properties"
				:clickable="true"
				@click="selectPlantio"
			/>

			<div v-if="showInfoPlantio">
				<PlantioMarker
					v-for="(plantioMarker, index) in plantioMarkers"
					:key="`${index}-plantioMarker`"
					:plantio-marker="plantioMarker"
					@showEstratoContinuos="showEstratoContinuos($event)"
					@showEstratoPreCorte="showEstratoPreCorte($event)"
				/>
			</div>
		</GmapMap>
	</div>
</template>
<script>
import SHAPE_OPTIONS_FZDA from '../../../../constants/ShapeOptions/ShapeFzda'
import { SHAPE_OPTIONS_PLANTIO_POLIGONO } from '../../../../constants/ShapeOptions/ShapePtio'
import SHAPE_OPTIONS_TLHO from '../../../../constants/ShapeOptions/ShapeTlho'

import PolygonShape from '../../../../components/Map/PolygonShape'
import PlantioMarker from '../../../../components/PlantioMarker/PantioMarker.vue'

import { mapGetters, mapMutations } from 'vuex'

import { getAllFazendas, getDropdownFazendas } from '../../../../services/requests/FazendaRequests'

import * as turf from '@turf/turf'

export default {
	components: {
		PolygonShape,
		PlantioMarker,
	},

	props: {
		showInfoPlantio: { type: Boolean, default: false },
	},
	methods: {
		...mapMutations('moduleImportShape', ['setBounds']),
		selectPlantio(e) {
			this.getGeoJsonPtio.features.forEach((feature) => {
				const { idPlantio, blocked } = feature.properties
				if (idPlantio === e.id && !blocked) {
					feature.properties.selected = !feature.properties.selected
				}
			})
		},

		showEstratoContinuos(e) {
			this.mostraContinuos = e
		},
		showEstratoPreCorte(e) {
			this.mostraPreCorte = e
		},
	},
	computed: {
		...mapGetters('moduleImportShape', [
			'plantioMarkers',
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'isGeoJsonPlantioEmpty',
		]),
	},

	data() {
		return {
			mostraContinuos: false,
			mostraPreCorte: false,
			shapeOptionsFzda: SHAPE_OPTIONS_FZDA,
			shapeOptionsTlho: SHAPE_OPTIONS_TLHO,
			shapeOptionsPtio: SHAPE_OPTIONS_PLANTIO_POLIGONO,
			/**
			 * Exibe ou não o card para importar os shapes
			 */
			showImportShape: false,
			/**
			 * Exibe ou não o card para mapear colunas do shape com o sistema
			 */
			showMapData: false,
			model: {
				id: '',
				fk_fzda_fazenda: '',
			},
		}
	},
	watch: {
		'$store.state.moduleImportShape.bounds': {
			immediate: true,
			deep: true,
			async handler(value) {
				if (Object.keys(value).length > 0 && this.$refs.planejamento_estrato_map) {
					this.$refs.planejamento_estrato_map.$mapPromise.then((map) => {
						map.fitBounds(value, 0)
					})
				}
			},
		},
	},
	created() {
		getDropdownFazendas().then((response) => {
			this.fazendas = response
			this.model = this.fazendas
		})

		getAllFazendas().then((response) => {
			const { result: fazendas3 } = response.data
			this.modelList = fazendas3
			this.modelList.unshift(fazendas3)
			this.model2 = fazendas3
		})

		if (!this.isGeoJsonPlantioEmpty) {
			console.log(turf.bbox(this.getGeoJsonPtio.geojson))
			this.setBounds(turf.bbox(this.getGeoJsonPtio.geojson))
		}
	},
}
</script>
<style>
.container__plantiosEstrato {
	position: fixed;
	left: 0;
	top: 2.5rem;
	height: 100%;
	width: 100vw;
	z-index: 200;
	font-size: 0.75rem;
}
.slider {
	-webkit-appearance: none;
	width: 100%;
	height: 15px;
	margin-bottom: 20px;

	border-radius: 5px;
	background: #d3d3d3;
	outline: none;
	opacity: 0.7;
	-webkit-transition: 0.2s;
	transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: absolute;
	top: 5rem;
	right: 0%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.slider::-moz-range-thumb {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
</style>
